export default "__VITE_ASSET__PlDy5$ZS__"